import type { Nullish } from '@iheartjane/types';

/**
 * A row setting as the roots store payload serves it. `menu_row_type` is the
 * canonical row name; `row_type` is operator-editable and may be renamed.
 */
interface CustomRowEnabledState {
  enabled: boolean;
  menu_row_type: string;
  row_type?: string;
}

type CustomRows = readonly (CustomRowEnabledState | string)[];

const isCustomRowEnabledState = (
  row: CustomRowEnabledState | string
): row is CustomRowEnabledState => typeof row !== 'string';

/**
 * Whether the store has a Jane-defined row (see `JANE_DEFINED_ROWS`) turned on.
 *
 * Accepts either shape the API serves for a store's rows: the marketplace store
 * payload sends a flat list of the row types that are currently active, while
 * the roots store payload sends row settings carrying their own `enabled` flag.
 */
export function hasJaneDefinedRowEnabled(
  customRows: Nullish<CustomRows>,
  rowType: string
): boolean {
  return (customRows ?? []).some((row) =>
    isCustomRowEnabledState(row)
      ? row.menu_row_type === rowType && row.enabled
      : row === rowType
  );
}
